

export interface IStatisticVote {
   id: string;
   name: string;
   photo: string;
   vote: number;
}

export const statisticVoteData: IStatisticVote[] = [
   {
      id: "1",
      name: 'Kostiantyn Lebid',
      photo: '/img/cardImage/LebidKoatya/Lebid_Koatya.jpg',
      vote: 15
   },
   {
      id: "2",
      name: 'Inna Mykytiuk',
      photo: '/img/cardImage/Mykytiuk/Photo_Mykytiuk_Inna.jpg',
      vote: 124
   },
   {
      id: "3",
      name: 'Kyrylo Pikhno',
      photo: '/img/cardImage/KyryloPikhno/Pikhno_photo.JPG',
      vote: 24
   },
   {
      id: "4",
      name: 'Evelina Karametulova',
      photo: '/img/cardImage/Evelina_Karametulova/Evelina_Karametulova.jfif',
      vote: 5
   },
   {
      id: "5",
      name: 'Denys Rukomostrov',
      photo: '/img/cardImage/Rukosmotrov_Denys/Personal_photo.jpg',
      vote: 10
   },
   {
      id: "6",
      name: 'Evgeny Grishin',
      photo: '/img/cardImage/EvgenyGrishin/Evgeny_Grishin.png',
      vote: 52
   },
   {
      id: "7",
      name: 'Bogdan Kozhoma',
      photo: '/img/cardImage/person2/MyPhoto_2.png',
      vote: 7
   },
   {
      id: "8",
      name: 'Yanoslav Kotenko',
      photo: '/img/cardImage/Kotenko_Yanoslav/Kotenko_Yanoslav.jpg',
      vote: 20
   },
   {
      id: "9",
      name: 'Maksym Kushchenko',
      photo: '/img/cardImage/Kushchenko_Maksym/Photo.jpg',
      vote: 35
   },
   {
      id: "10",
      name: 'Anton Bondar',
      photo: '/img/cardImage/person1/photo.jpg',
      vote: 6
   },




];